export const NAMESPACE = 'AUTH';